<template>
  <div class="keyfigures">
    <div v-for="(figure, key) in figures" :key="key" class="keyfigure">
      <div class="keyfigure-inner">
        <div class="keyfigure-label f-ui-3">
          {{ figure.label }}
        </div>
        <Sparkline
          v-if="figure.sparkline && tesdata.length > 1"
          :data="tesdata"
        />
        <div class="keyfigure-figure">
          <span class="f-number-2" :class="key">{{ figure.value }}</span>
          <span class="f-ui-3"> {{ figure.unit }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tes from "../../source/tes.json";
import Sparkline from "./Sparkline.vue";
import gsap from "gsap";
export default {
  components: {
    Sparkline,
  },
  data() {
    return {
      figures: {},
    };
  },
  mounted() {
    this.figures = {
      share: {
        type: "figure",
        label: "Share of total energy supply of IEA members",
        value: 0,
        unit: "%",
      },
      tes: {
        sparkline: true,
        label: "Total energy supply of the world",
        value: 0,
        unit: "PJ",
      },
    };
  },
  computed: {
    tesdata() {
      const { year } = this;
      return tes.filter((d) => d.year <= year).map((d) => [d.year, d.world]);
    },
  },
  props: {
    year: {
      required: true,
    },
  },
  watch: {
    year(curr, prev) {
      const max = Math.max(...tes.map((d) => d.year));
      if (curr > max) return;
      if (curr) this.updateKeyFigure(curr, prev);
    },
  },
  methods: {
    formatValue(value, key) {
      return key === "share" ? (value * 100).toFixed(2) : value;
    },
    updateKeyFigure(curr, prev) {
      const { separator } = this;
      const currYear = tes.find((d) => d.year === curr);
      const prevYear = tes.find((d) => d.year === prev);
      const { world, members, association } = currYear;
      let oldtes = prev ? prevYear.members : 0;
      gsap.fromTo(
        ".tes",
        {
          textContent: oldtes / 1000,
          snap: { textContent: 1 },
          ease: "power1.in",
          stagger: {
            each: 1,
            onUpdate: function () {
              this.targets()[0].innerHTML = separator(
                Math.ceil(this.targets()[0].textContent)
              );
            },
          },
        },
        {
          textContent: members / 1000,
          snap: { textContent: 1 },
          ease: "power1.in",
          stagger: {
            each: 1,
            onUpdate: function () {
              this.targets()[0].innerHTML = separator(
                Math.ceil(this.targets()[0].textContent)
              );
            },
          },
        }
      );
      gsap.to(".share", {
        textContent: (((members + association) / world) * 100).toFixed(2),
        snap: { textContent: 0.01 },
        ease: "power1.in",
      });
    },
    separator(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
  },
};
</script>

<style>
.keyfigures {
  width: 100%;
  margin-top: 32px;
  opacity: 1;
}
.keyfigure-inner {
  padding: 8px;
}
.keyfigure:not(:first-child) {
  margin-top: 12px;
}
.keyfigure-label {
  width: 55%;
  color: #6f6f6f;
}
.keyfigure-figure {
  padding-top: 6px;
  color: #04f;
}
@media screen and (max-width: 959px) {
  .keyfigure-label {
    width: 80%;
    color: #6f6f6f;
  }
  .keyfigures {
    margin-top: 16px;
  }
  .keyfigure-inner {
    padding: 0 8px;
  }
}
@media screen and (max-width: 499px) {
  .keyfigures {
    display: none;
  }
}
</style>
